import React, { Component } from 'react';
import { SelectSublocation } from './SelectSublocation';
import { SublocationSearch } from './SublocationSearch';

export class ItemLookupSublocationManagement extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.log("SUBLOCATION SEARCH RESULTS",this.props.sublocationSearchResults);
        return (
            <>
                {
                    <div className="sublocation-header">
                        {this.props.sublocationActionHeader}
                    </div>
                }
                <SublocationSearch
                    updateInputValue={this.props.updateInputValue}
                    focusOnInput={this.props.focusOnInput}
                    sublocationInput={this.props.sublocationInput}
                    findSublocation={this.props.findSublocation}
                />
                {
                    this.props.sublocationSearchResults.length > 0 &&
                    <SelectSublocation
                        sublocationSearchResults={this.props.sublocationSearchResults}
                        selectSublocation={this.props.selectSublocation}
                        selectNewSublocation={this.props.selectNewSublocation}
                        sublocationId={this.props.newSublocation}
                        useCheckboxes={true}
                    />
                }
                <div className="subloc-manage-buttons">
                    {
                        this.props.sublocationSearchResults.length > 0 &&
                        this.props.newSublocation &&
                        this.props.sublocationButton
                    }
                    <button className="cancel-button" onClick={() => { this.props.cancelSublocationUpdate() }}>Cancel</button>
                </div>
            </>
        );
    }
}